import React, { useState } from 'react';

interface Props {
  onLogin: (username: string, password: string) => void;
}

const LoginPage: React.FC<Props> = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onLogin(username, password);
  };

  return (
    <div
      dir="rtl"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: '5rem',
        fontFamily: "'IRANSans', system-ui, Segoe UI, Roboto, sans-serif"
      }}
    >
      <h2 style={{ marginBottom: '1.5rem' }}>ورود به سیستم</h2>

      <form
        onSubmit={handleSubmit}
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
          width: '300px'
        }}
      >
        <input
          type="text"
          placeholder="نام کاربری"
          value={username}
          onChange={e => setUsername(e.target.value)}
          style={{ fontSize: '1.1rem', padding: '0.75rem', borderRadius: 6, border: '1px solid #ccc' }}
          required
        />

        <input
          type="password"
          placeholder="رمز عبور"
          value={password}
          onChange={e => setPassword(e.target.value)}
          style={{ fontSize: '1.1rem', padding: '0.75rem', borderRadius: 6, border: '1px solid #ccc' }}
          required
        />

        <button
          type="submit"
          style={{
            fontSize: '1.1rem',
            padding: '0.75rem',
            background: '#1976d2',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer'
          }}
        >
          ورود
        </button>
      </form>
    </div>
  );
};

export default LoginPage;
